import React from "react"

import { useRemainingTime } from "./hooks"
import { toMMSS } from "./utils"

interface Props {
  cumulativePrice?: number
  cycleStartedAt?: number
}

/** 적립 진행 중. 오늘의 누적 금액과 다음 적립까지 남은 시간을 보여준다 */
const Accruing = ({ cumulativePrice, cycleStartedAt }: Props) => {
  const remainingTime = useRemainingTime(cycleStartedAt)

  const renderRemainingTime = () => {
    // 주기가 시작되기 전이거나 방송이 끝나 잴 대상이 없는 경우
    if (remainingTime === undefined) return "-"

    // 적립 요청을 보냈지만 아직 응답이 오지 않은 구간
    return remainingTime <= 0 ? "적립 중" : toMMSS(remainingTime)
  }

  return (
    <div className="wmRow">
      <span className="wmItem">
        <span className="wmLabel">오늘의 누적 와우머니</span>
        <strong className="wmValue">
          {cumulativePrice === undefined
            ? "-"
            : cumulativePrice.toLocaleString()}
          <span className="wmUnit">원</span>
        </strong>
      </span>
      <span className="wmDivider" />
      <span className="wmItem">
        <span className="wmLabel">추가적립까지 남은시간</span>
        <strong className="wmValue wmTime">{renderRemainingTime()}</strong>
      </span>
    </div>
  )
}

export default Accruing
